import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import { Checkbox, Grid, IconButton } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp, TuneOutlined } from '@material-ui/icons';
import { Form, Select as SelectAntd, Input } from 'antd';
import InvisibleContent from '@components/Shared/InvisibleContent';

import ButtonWithIcon from '@components/Shared/Buttons/ButtonWithIcon';
import Button from '@components/Shared/Buttons/Button';
import Filtros from '@src/components/Shared/Filtros';
import Modal from '@src/components/Shared/Modal/ModalPure';
import ApproveSolicitacao from '@components/Shared/Solicitacao/approveSolicitacao';
import RecuseSolicitacao from '@components/Shared/Solicitacao/recuseSolicitacao';

import CountDown from '@components/Shared/CountDown';
import TableCollapsible from '@components/Shared/Tables/TableColapseNoPaginationWithSelection';
import TableCollapsibleFiltros from '@components/Shared/Tables/TableColapseNoPaginationWithSelectionFiltros';

import { TitlePage } from '@src/@styles/styles.global';
import { useAuth } from '@hooks/AuthenticateContext';

import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';

import Services, {
  ISolicitacoes,
  ITipoSolicitacao,
  ISolicitacaoResultTable,
  ISolicitacoesFiltros
} from './services';


import {
  StyledTableCell,
} from '@src/components/Shared/Tables/TableCollapsible/styles';

const columnsLabel = {
  Data: 'Solicitado em',
  IDCadastro: 'ID pessoa',
  IDPerfil: 'ID perfil',
  NomeCadastro: 'Nome',
  Campanha: 'Campanha',
  Perfil: 'Perfil',
  SolicitadoPor: 'Solicitado por',
  Banco: 'Banco',
  Observacao: [
    {
      coluna: 'string',
      valor: 'string',
    },
  ],

};

const columnsLabelFiltros = {
  Data: 'Solicitado em',
  IDCadastro: 'ID pessoa',
  IDPerfil: 'ID perfil',
  NomeCadastro: 'Nome',
  Campanha: 'Campanha',
  Perfil: 'Perfil',
  SolicitadoPor: 'Solicitado por',
  TipoSolicitacaoDescricao: 'Solicitação',
  Banco: 'Banco',
  Observacao: [
    {
      coluna: 'string',
      valor: 'string',
    },
  ],

};

interface ITest {
  Data: string;
  TipoSolicitacao: string;
  valor: string;
  dataVencimento: string;
  solicitadoPor: string;
  idStatusSolicitacao: number;
  StatusSolicitacao: string;
  Observacao: [
    {
      coluna: string;
      valor: string;
    },
  ];
}


interface IProps {
  idPerfil: number;
  functionReload?: Function;
  idSolicitacao: number;
}

const ListSolicitacao: React.FC<IProps> = ({
  idPerfil,
  functionReload,
  idSolicitacao,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<ISolicitacoes[]>([]);
  const [dataFiltros, setDataFiltros] = useState<ISolicitacoesFiltros[]>([]);
  const [tipoSolicitacaoSelected, setTipoSolicitacaoSelected] = useState(0);
  const [tipoSolicitacao, setTipoSolicitacao] = useState<ITipoSolicitacao[]>(
    [] || null,
  );
  const [openModalApproveSolicitacao, setOpenModalApproveSolicitacao] =
    useState(false);
  const [openModalRecuseSolicitacao, setOpenModalRecuseSolicitacao] =
    useState(false);

  const [dadosSelecionadas, setDadosSelecionadas] = useState<string[]>([]);
  const [dadosSelecionados, setDadosSelecionados] = useState<any[]>([]);

  const [filtros, setFiltros] = useState(false);

  const [idSelect, setIdSelect] = useState<string>('');
  const [nomeSelect, setNomeSelect] = useState<string>('');

  const [loadingFiltros, setLoadingFiltros] = useState(false);


  async function loadCampanhas() {
    const services = new Services();

    const { error, response } = await services.getTipoSolicitacao();
    if (!error && response?.length) {
      setTipoSolicitacao(response);
      setTipoSolicitacaoSelected(response[0].id);
      loadTipoSolicitacao(response[0].id);
    }
  }

  const loadTipoSolicitacao = async (id_tipo_solicitacao: number) => {
    setLoading(true);
    setLoadingFiltros(false);

    const services = new Services();

    const { error, response } = await services.loadTipoSolicitacao({
      id_tipo_solicitacao: id_tipo_solicitacao,
    });

    if (!error && response) {
      setData(response);
    }

    setLoading(false);
    clearDados()
  };

  const loadTipoSolicitacaoFiltros = async () => {
    setLoading(true);
    setLoadingFiltros(true);
    const services = new Services();

    const { error, response } = await services.loadTipoSolicitacaoFiltros(idSelect, nomeSelect);

    if (!error && response) {
      setDataFiltros(response);
    }

    setLoading(false);
  };

  const finishRecuseSolicitacao = async () => {
    if (functionReload) {
      await functionReload();
    }
    setOpenModalRecuseSolicitacao(false);
  };

  const finishApproveSolicitacao = async () => {
    if (functionReload) {
      await functionReload();
    }
    setOpenModalApproveSolicitacao(false);
  };



  const selectedDatas = (row: any) => {
    setDadosSelecionados(prev =>
      prev.some(r => r.IDSolicitacao === row.IDSolicitacao)
        ? prev.filter(r => r.IDSolicitacao !== row.IDSolicitacao)
        : [...prev, row]
    );
  };

  const onSelectAll = (rows: ISolicitacaoResultTable[]) => {
    setDadosSelecionados(prev =>
      prev.length === rows.length ? [] : rows
    );
  };

  const handleOpen = () => {
    setFiltros(!filtros);
  };

  console.log("FILTROS", loadingFiltros)

  const clearDados = () => {
    formRef.setFieldsValue({
      id_perfil: '',
    });

    formRef.setFieldsValue({
      nome: '',
    });
    console.log("meus deus")
  };


  useEffect(() => {
    loadCampanhas();
    window.document.title = 'CRM - Lista de Solicitações';
  }, []);

  const { user, signOut } = useAuth();

  {/*/Bloqueio inspecionar
   useEffect(() => {
  if (user.role !== 'ADM SOCIALLIS') {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'F12') {
        event.preventDefault();
        alert('F12 está desativado.');
      }
      if (event.ctrlKey && event.shiftKey && event.key === 'I') {
        event.preventDefault();
        alert('Ctrl+Shift+I está desativado.');
      }
      if (event.ctrlKey && event.shiftKey && event.key === 'J') {
        event.preventDefault();
        alert('Ctrl+Shift+J está desativado.');
      }
      if (event.ctrlKey && event.key === 'U') {
        event.preventDefault();
        alert('Ctrl+U está desativado.');
      }
    };

    const detectDevTools = () => {
      const threshold = 160;
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold = window.outerHeight - window.innerHeight > threshold;

      if (widthThreshold || heightThreshold) {
        alert('Ferramentas de desenvolvedor detectadas.');
        window.location.href = '/';
      }
    };

    const interval = setInterval(detectDevTools, 1000);

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      clearInterval(interval);
    };
  }
}, [user.role]); */}

const toggleSelect = (id: number) => {
  setDadosSelecionados((prev) =>
    prev.includes(id)
      ? prev.filter(x => x !== id)
      : [...prev, id]
  );
};

const dadosSelecionadosLimpos = dadosSelecionados.map(item => item.IDSolicitacao);

  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <TitlePage style={{ margin: 5 }}>Solicitações</TitlePage>
      </Grid>

      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >
        <Grid item md={3} xs={4} style={{ margin: 5 }} >
          <Form.Item>
            <SelectAntd
              style={{ width: '80%' }}
              placeholder="Tipo de solicitação"
              onChange={(e: number) => {
                setTipoSolicitacaoSelected(e);
                loadTipoSolicitacao(e);
              }}
              value={tipoSolicitacao[0] ? tipoSolicitacaoSelected : 0}
            >
              {tipoSolicitacao.map((option, index) => (
                <SelectAntd.Option key={option.id} value={option.id}>
                  {option.descricao}
                </SelectAntd.Option>
              ))}
            </SelectAntd>
          </Form.Item>
        </Grid>

        <Grid item md={2} xs={4} style={{ margin: 5 }} >
              <Button
                color="secondary"
                fullWidth
                style={{
                  height: 37,
                  width: 150
                }}
                onClick={handleOpen}
              >
                <TuneOutlined style={{ marginRight: 10 }} /> Filtros
              </Button>
            </Grid>

        <Modal
          title="Recusar solicitações"
          size="medio"
          openModal={openModalRecuseSolicitacao}
          controlModal={(value: boolean) =>
            setOpenModalRecuseSolicitacao(value)
          }
        >
          <RecuseSolicitacao
            perfil_id={idPerfil}
            finishCreate={finishRecuseSolicitacao}
            ids_solicitacao={dadosSelecionadosLimpos}
          />
        </Modal>

        <Grid item md={2} xs={4} style={{ margin: 5 }}>
          <ButtonWithIcon
            color="tertiary"
            fullWidth
            disabled={dadosSelecionados.length <= 0}
            onClick={() => setOpenModalRecuseSolicitacao(true)}
            titleButton="Recusar solicitações "
            //</Grid>Icon={() => (
              //<Icon path={mdiArrowBottomRight} size={1} color="White" />
            //)}
          ></ButtonWithIcon>
        </Grid>

        <Modal
          title="Aprovar solicitações"
          size="medio"
          openModal={openModalApproveSolicitacao}
          controlModal={(value: boolean) =>
            setOpenModalApproveSolicitacao(value)
          }
        >
          <ApproveSolicitacao
            perfil_id={idPerfil}
            finishCreate={finishApproveSolicitacao}
            id_solicitacao={dadosSelecionadosLimpos}
          />
        </Modal>

        <Grid item md={2} xs={4} style={{ margin: 5 }}>
          <ButtonWithIcon
            color="secondary"
            fullWidth
            disabled={dadosSelecionados.length <= 0}
            onClick={() => setOpenModalApproveSolicitacao(true)}
            titleButton="Aprovar solicitações"
            //Icon={() => <Icon path={mdiArrowTopRight} size={1} color="White" />}
          ></ButtonWithIcon>
        </Grid>
      </Grid>

      {/* Filtros  */}
      <Filtros abrir={filtros} openMenu={handleOpen}>
            <Grid
              item
              md={12}
              lg={12}
              xs={12}
              style={{ paddingRight: 10, paddingLeft: 10, paddingTop: 10 }}
            >
              <Form className="filtros" layout={'vertical'} form={formRef}
               initialValues={{
                id_perfil: '',
                nome: '',
              }}>

                <Grid
                  item
                  md={12}
                  lg={12}
                  xs={12}
                  style={{
                    paddingRight: 10,
                    paddingLeft: 10,
                    alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                  <Form.Item
                    name="id_perfil"
                  >
                    <p style={{color: '#fff'}}>ID Perfil:</p>
                    <Input onChange={(e: any) => {setIdSelect(e.target.value);}} type="number"/>
                  </Form.Item>
                </Grid>

                <Grid
                  item
                  md={12}
                  lg={12}
                  xs={12}
                  style={{
                    paddingRight: 10,
                    paddingLeft: 10,
                    alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                  <Form.Item
                    name="nome"
                  >
                    <p style={{color: '#fff'}}>Nome:</p>
                    <Input onChange={(e: any) => {setNomeSelect(e.target.value);}}/>
                  </Form.Item>
                </Grid>

                <Grid
                  item container
                  md={12}
                  lg={12}
                  xs={12}
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    //alignSelf: 'flex-end',
                    //paddingTop: 10,
                  }}
                >
                  <Grid
                  item
                  md={12}
                  lg={12}
                  xs={12}
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    //alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                  <Button
                    color="primary"
                    fullWidth
                    style={{
                      height: 46,
                    }}
                    onClick={loadTipoSolicitacaoFiltros}
                    //onClick={() => {loadListaAllIntencaoMissaFiltros(); loadAllIntencoesFiltros()}}

                  >
                   Buscar
                  </Button>
                </Grid>

                {/*<Grid
                  item
                  md={5}
                  lg={5}
                  xs={12}
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    //alignSelf: 'flex-end',
                    paddingTop: 10,
                  }}
                >
                  <Button
                    color="default"
                    fullWidth
                    style={{
                      height: 46,
                    }}
                    onClick={(e: any) => {clearDados()}}
                    //onClick={clearDados}
                  >
                    Limpar filtros
                  </Button>
                  </Grid>*/}
                </Grid>
              </Form>
            </Grid>
          </Filtros>

      <Grid item lg={12} xs={12}>
       {/* <CountDown
          minutesDefault={1}
          changeFunction={loadTipoSolicitacao}
          title="Tempo para atualização dos dados"
        /> */}
      </Grid>
      <Grid item lg={10} xs={12}>
        <InvisibleContent visible={loadingFiltros === false}>
        <TableCollapsible

          loading={loading}
          columns={[columnsLabel]}
          FieldsBold={['Perfil']}
          data={data}
          selectedRows={dadosSelecionados}
          onSelectRow={selectedDatas}
          onSelectAll={onSelectAll}
          keys={[
            'Data',
            'IDCadastro',
            'IDPerfil',
            'NomeCadastro',
            'Perfil',
            'Campanha',
            'SolicitadoPor',
            'Banco',
          ]}
          ActionHeader="Detalhes"
          Actions={[
            {
              Button: (row: ITest) => {
                const [open, setOpen] = React.useState(false);
                return (
                  <TableContainer>
                    <TableRow>
                      <StyledTableCell>
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={() => setOpen(!open)}
                        >
                          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                      </StyledTableCell>
                    </TableRow>
                  </TableContainer>
                );
              },
            },
          ]}
        />
        </InvisibleContent>

        <InvisibleContent visible={loadingFiltros === true}>
        <TableCollapsibleFiltros
          /*Selected={(e: ISolicitacaoResultTable) => (
            <Grid container justifyContent="center">
              <Checkbox
                onChange={() => selectedDatas(e)}
                checked={
                  dadosSelecionadas.filter(x => x === e.IDSolicitacao).length >
                  0
                }
              />
            </Grid>
              )}*/
          loading={loading}
          columns={[columnsLabelFiltros]}
          FieldsBold={['Perfil']}
          data={dataFiltros}
          selectedRows={dadosSelecionados}
          onSelectRow={selectedDatas}
          onSelectAll={onSelectAll}
          keys={[
            'Data',
            'IDCadastro',
            'IDPerfil',
            'NomeCadastro',
            'Perfil',
            'Campanha',
            'SolicitadoPor',
            'TipoSolicitacaoDescricao',
            'Banco',
          ]}
          ActionHeader="Detalhes"
          Actions={[
            {
              Button: (row: ITest) => {
                const [open, setOpen] = React.useState(false);
                return (
                  <TableContainer>
                    <TableRow>
                      <StyledTableCell>
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={() => setOpen(!open)}
                        >
                          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                      </StyledTableCell>
                    </TableRow>
                  </TableContainer>
                );
              },
            },
          ]}
        />
        </InvisibleContent>
      </Grid>
    </Grid>
  );
};

export default ListSolicitacao;
